import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
    alpha,
    Box,
    Card,
    CardActionArea,
    CardContent,
    Container,
    Grid,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { LIBRARIAN_LIBRARY_NAV } from "../../config/librarianLibraryNav";

const ICONS = {
    "/Teacher/library": MenuBookOutlinedIcon,
};

const LibrarianHomePage = ({ withTeaching = false }) => {
    const { currentUser } = useSelector((state) => state.user);

    return (
        <Box
            sx={{
                minHeight: withTeaching ? "auto" : "100%",
                py: { xs: 2, sm: 3 },
                background: (t) =>
                    t.palette.mode === "light"
                        ? `linear-gradient(180deg, ${alpha(t.palette.info.main, 0.06)} 0%, ${t.palette.grey[50]} 35%)`
                        : alpha(t.palette.common.black, 0.12),
            }}
        >
            <Container maxWidth="lg">
                <Paper elevation={0} sx={{ p: { xs: 2.5, sm: 3 }, borderRadius: 3, mb: 3 }}>
                    <Typography variant="h5" fontWeight={800} gutterBottom>
                        {withTeaching ? "Library & teaching" : "Library office"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Welcome, {currentUser?.name || "Librarian"}.
                        {withTeaching
                            ? " Manage the library below, then scroll down for your teaching dashboard and subject tools."
                            : ` Manage books, teaching-learning materials (TLMs), borrowing, and stock for ${currentUser?.school?.schoolName || "your school"}.`}
                    </Typography>
                </Paper>

                <Grid container spacing={2}>
                    {LIBRARIAN_LIBRARY_NAV.map((item) => {
                        const Icon = ICONS[item.to] || MenuBookOutlinedIcon;
                        return (
                            <Grid item xs={12} sm={6} md={4} key={item.to}>
                                <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
                                    <CardActionArea component={Link} to={item.to} sx={{ height: "100%" }}>
                                        <CardContent>
                                            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                                <Icon color="primary" />
                                                <Box>
                                                    <Typography fontWeight={700}>{item.label}</Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {item.hint}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default LibrarianHomePage;
